import Vue from 'vue'
import App from './app.vue'
import iView from 'iview'
import preImage from './components/preImage/imagePlugin'
import { router } from './router/index';
//import 'iview/dist/styles/iview.css';
import 'famfamfam-flags/dist/sprite/famfamfam-flags.css';
import './theme.less';
import Vuex from 'vuex';
import Ajax from './lib/ajax';
import Util from './lib/util'
import qs from 'qs'
//手机端适配
// import 'amfe-flexible/index.js'
// import mui from 'mui'
// import mui from '@/assets/mui/js/mui.min.js'
// Vue.prototype.mui = mui
//
import SignalRAspNetCoreHelper from './lib/SignalRAspNetCoreHelper'
Vue.use(iView);
Vue.use(preImage);

import store from './store/index';
Vue.config.productionTip = false
import { appRouters } from './router/router'
if (!abp.utils.getCookieValue('Abp.Localization.CultureName')) {
  let language = navigator.language;
  abp.utils.setCookieValue('Abp.Localization.CultureName', language, new Date(new Date().getTime() + 5 * 365 * 86400000), abp.appPath);
}

Ajax.get('/AbpUserConfiguration/GetAll').then(async data => {
  
  Util.abp = Util.extend(true, Util.abp, data.data.result);
  //获取菜单
  if(Util.abp.session.userId){//判断是否已登录
    // if(/Android|webOS|iPhone|iPod|BlackBerry|SymbianOS|Windows Phone/i.test(navigator.userAgent)) {//判断是否手机端
    //     window.location.href = "#/mobile";
    // }
    await store.dispatch({
      type: 'session/init'
    })

    // let params = new URLSearchParams()
    // params.append('roles', store.state.session.roleIds)

    let rep:any =await Ajax.get(`/api/services/app/AbpMenu/GetAllMenusByRoles`, {
      params: {
        roles: store.state.session.roleIds
      },
      paramsSerializer: params => {
        return qs.stringify(params, { indices: false })
      }
    })
    if(rep.data.success){
      let req:any =await Ajax.get("/api/services/app/AbpMenu/GetAllListByTenant")
      // 路由权限控制
      if(req.data.success){
        for (let i=0;i<req.data.result.items.length;i++){
          for (let j =0;j<rep.data.result.items.length;j++){
            let isexist = false;
            for (let k =0;k<rep.data.result.items.length;k++){
              if (req.data.result.items[i].id==rep.data.result.items[k].id){
                isexist = true
              }
            }
            if(req.data.result.items[i].id==rep.data.result.items[j].parentId&&!isexist){
              rep.data.result.items.push(req.data.result.items[i])
            }
          }
        }
      }
      let temp = Util.abp.auth.getJsonTree(rep.data.result.items,'deebd3f0-8a2d-41d6-810a-fb451bd59204')
      // let sort = []
      let parent_index = 0
      let parent_temp = []
      let temp_child = []
      let child_index = 0
      // 菜单排序
      for(let i=0;i<temp.length;i++){
        parent_temp = temp[i]
        parent_index = i
        for(let j=i+1;j<temp.length;j++){
          if(parent_temp.sort>temp[j].sort){
            parent_temp = temp[j];
            parent_index = j
          }
        }
        temp[parent_index] = temp[i]
        temp[i] = parent_temp
      }
      for(let k=0;k<temp.length;k++){
        for(let i=0;i<temp[k].children.length;i++){
          temp_child = temp[k].children[i]
          child_index = i
          for(let j=i+1;j<temp[k].children.length;j++){
            if(temp_child.sort>temp[k].children[j].sort){
              temp_child = temp[k].children[j]
              child_index = j
            }
          }
          temp[k].children[child_index] = temp[k].children[i]
          temp[k].children[i] = temp_child
        }
      }
      // 提成系统流程汇总 取消下拉
      temp.forEach((el:any,index:any) => {
        if (el.meta.title === '提成系统' || el.meta.title === '帮助中心' || el.meta.title === '流程中心' || el.meta.title === '培训管理' || el.meta.title === '满意度调查表') {
          temp[index].children = []
        }
      })

      Util.abp.auth.new_menu = temp
    }
  }
  //
  new Vue({
    render: h => h(App),
    router: router,
    store: store,
    data: {
      currentPageName: ''
    },
    async mounted() {
      this.currentPageName = this.$route.name as string;
      await this.$store.dispatch({
        type: 'session/init'
      })
      if (!!this.$store.state.session.user && this.$store.state.session.application.features['SignalR']) {
        if (this.$store.state.session.application.features['SignalR.AspNetCore']) {
          SignalRAspNetCoreHelper.initSignalR();
        }
      }
      this.$store.commit('app/initCachepage');
      this.$store.dispatch('todoCount')
    },
    created() {
      this.$store.commit('app/updateMenulist');
      let tagsList: Array<any> = [];
      appRouters.map((item: any) => {
        if (item.children.length <= 1) {
          tagsList.push(item.children[0]);
        } else {
          tagsList.push(...item.children);
        }
      });
      this.$store.commit('app/setTagsList', tagsList);
    }
  }).$mount('#app')
})

